import { FC } from "react";
import { useParams } from "react-router-dom";

import { useCrudNavigate } from "@ryde/redux";
import { DrawerType, EditFormMode } from "@ryde/shared";

import { NotificationEditFormDrawer } from "../notification-edit-form-drawer";

export const NotificationEdit: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { navigateToList } = useCrudNavigate("notification");
  const idOpen = Number(id) || undefined;

  return (
    <NotificationEditFormDrawer
      type={DrawerType.NotificationEditForm}
      mode={EditFormMode.CrudRoute}
      onCloseDrawer={navigateToList}
      id={idOpen}
    />
  );
};
